import { STICKY_ALERT_TYPE, StickyAlertType } from '@/modules/alerts/models/sticky-alert-type';
import { Component } from 'vue';
import WCTestStickyAlert from '@/modules/alerts/components/WCTestStickyAlert/WCTestStickyAlert.vue';
import WCBasicStickyAlert from '@/modules/alerts/components/WCBasicStickyAlert/WCBasicStickyAlert.vue';

const STICKY_ALERT_COMPONENT_REGISTRY: Record<StickyAlertType, Component> = {
  [STICKY_ALERT_TYPE.TEST]: WCTestStickyAlert,
  [STICKY_ALERT_TYPE.BASIC]: WCBasicStickyAlert,
};

export default STICKY_ALERT_COMPONENT_REGISTRY;
